import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import { SIGN_UP } from 'components/pages/pages';
import React from 'react';
import classes from './LandingPageCta.module.scss';

const LandingPageCta: React.FC = () => {
  return (
    <div className={classes.wrapper}>
      <A href={SIGN_UP.path} className={classes.ctaButton}>
        <Txt>Sign up for free and start earning</Txt>
      </A>
    </div>
  );
};

export default LandingPageCta;
